import { type QueryHookOptions, QueryResult } from "@apollo/client/react/types/types";
import { FIND_EMPLOYER_QUERY } from "../Queries";
import { useQuery } from "@apollo/client";
import { Employer } from "../generated/graphql";
import { AuthContextProps } from "oidc-react";

export function useEmployer(auth?: AuthContextProps, options?: QueryHookOptions): QueryResult<{ findEmployer: Employer | null }> {
    const user = auth?.userData;
    const signedIn = !!user;
    return useQuery(FIND_EMPLOYER_QUERY, {
        skip: !signedIn,
        ...options
    })
}